import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useOptionImageStore } from './option-image';
import { useFeatureListStore } from './feature-list';
import { resolvePackagePriceDisplay } from './package-price';
import { usePriceListStore } from './price-list';
export const useOptionalStore = defineStore('optional', {
    state() {
        return {
            optionImgMap: {},
        };
    },
    getters: {
        /**
         * 选配列表
         */
        optionalList() {
            const featureListStore = useFeatureListStore();
            const optionImageStore = useOptionImageStore();
            const priceList = usePriceListStore();
            if (!featureListStore.data)
                return [];
            const optionalCodeList = [
                CategoryCode.Optional,
                SubCategoryCode.SubOptional,
                FeatureType.SubOptional,
            ];
            const featureItem = getFeatureData(optionalCodeList, featureListStore.data);
            return featureItem?.option_list?.map((option) => {
                const item = featureListStore.data?.option_map[option];
                // 套装展示：命中 package_price_list 优先，否则保留 feature/list option 上的 package_price_desc（见 package-price.ts）
                const packagePriceDisplay = resolvePackagePriceDisplay({
                    optionCode: item?.code,
                    price: item?.price,
                    packagePriceList: featureListStore.effectivePackagePriceList,
                    optionPackagePriceDesc: item?.package_price_desc,
                });
                const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[option] || '';
                const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[option] || {
                    icon: '',
                    icon_ratio: 0,
                };
                const discountData = {
                    discount_selected: !!priceDiscountTip,
                    discount_tip: priceDiscountTip || item?.discount_tip || '',
                    discount_tip_icon: priceDiscountTipIcon?.icon || item?.discount_tip_icon || '',
                    discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || item?.discount_tip_icon_ratio || 0,
                };
                const material = optionImageStore.commonImgs(SubCategoryCode.SubOptional, item?.code ?? '')?.[0];
                // let img = ''
                // 如果是对象的话
                // if (typeof material === 'object') {
                //   if (material.type === 'video') {
                //     img = material.img
                //   } else {
                //     img = material.material
                //   }
                // }
                if (item?.code) {
                    this.optionImgMap[item?.code] = material;
                }
                return {
                    ...item,
                    imgSrc: material,
                    ...packagePriceDisplay,
                    ...discountData,
                };
            });
        },
    },
});
